import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    dialogActionGridContainer: {
      padding: 5,
      '& .dialogActionSaveButton': {
        borderRadius: '4px',
        height: 44,
        '&:disabled': {
          backgroundColor: 'rgba(255, 255, 255, 0.4)',
        },
      },
    },
    dialogActionGrid: {
      marginRight: 22,
      fontWeight: 700,
      lineHeight: '20px',
    },
    dialogActionSaveButtonLabel: {
      color: MaterialPalette.common.black,
    },
    card: {
      padding: '16px',
    },
    photosDialogGrid: {
      marginTop: 16,
      marginBottom: 1,
      borderRadius: '10px 10px 0px 0px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    editDefPhotosLabel: {
      padding: '8.5px 0px 7.5px 4px',
      fontStyle: 'normal',
      width: '20%',
    },
    inlineBlock: {
      width: 'max-content',
      float: 'right',
      marginTop: '6px',
    },
    addDeficiencyButtonIcon: {
      paddingRight: 10,
      writingMode: 'vertical-rl',
    },
    editDefImagesCarouselGrid: {
      borderRadius: '0px 0px 10px 10px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    editDefImagesCarouselContainer: {
      padding: 8,
      '& .rec-arrow-right:hover:enabled, & .rec-arrow-right:focus:enabled': {
        backgroundColor: 'white',
        color: 'black',
        position: 'sticky',
        lineHeight: '40px',
        height: '40px',
        width: '40px',
        minWidth: '40px',
        borderRadius: '100%',
        zIndex: 2,
      },
      '& .rec-arrow-left:hover:enabled , & .rec-arrow-left:focus:enabled': {
        backgroundColor: 'white',
        color: 'black',
        position: 'sticky',
        lineHeight: '40px',
        height: '40px',
        width: '40px',
        minWidth: '40px',
        borderRadius: '100%',
        zIndex: 2,
      },
      '& .rec-arrow-left:enabled, & .rec-arrow-right:enabled': {
        backgroundColor: 'white',
        color: 'black',
        position: 'sticky',
        lineHeight: '40px',
        height: '40px',
        width: '40px',
        minWidth: '40px',
        borderRadius: '100%',
        zIndex: 2,
      },
      '& .rec-arrow-left': {
        color: 'black',
        backgroundColor: 'rgba(255, 255, 255, 0.16)',
        position: 'sticky',
        lineHeight: '40px',
        height: '40px',
        width: '40px',
        borderRadius: '100%',
        minWidth: '40px',
        zIndex: 2,
      },
      '& .rec-arrow-right': {
        color: 'black',
        backgroundColor: 'rgba(255, 255, 255, 0.16)',
        position: 'sticky',
        lineHeight: '40px',
        height: '40px',
        width: '40px',
        borderRadius: '100%',
        minWidth: '40px',
        zIndex: 2,
      },
      '& .rec-slider-container': {
        margin: '0px -40px',
      },
    },
    defNoPhotosLabel: {
      padding: '0px 8px',
      color: 'rgba(255, 255, 255, .60)',
    },
    dialogActionGridLink: {
      textDecoration: 'none',
    },
    updateHistory: {
      cursor: 'pointer',
      position: 'absolute',
      top: '18px',
      paddingRight: '15px',
    },
  }),
);

export default useStyles;
